// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-e4y","left":"styles_left__3dlVx","desktopActions":"styles_desktopActions__1PYQ2","title":"styles_title__3C70W"};